import React, { useContext } from 'react';
import { defaults } from 'lodash';

import { ButtonThemeProps } from '../components/button';
import { TableThemeProps } from '../components/table';

export type Theme = {
  button?: ButtonThemeProps;
  table?: TableThemeProps;
};

const ThemeContext = React.createContext<Theme>({});

export const ThemeProvider = ({
  value,
  children,
}: {
  children: React.ReactNode;
  value: Theme;
}) => {
  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => {
  return useContext(ThemeContext);
};

export const useComponentTheme = <T extends keyof Theme>(
  componentName: T,
  props: Theme[T]
) => {
  const theme = useTheme();
  const componentTheme = theme[componentName];

  return defaults({}, props, componentTheme);
};
